
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { AjaxBasics } from '@xt/client/helpers'
import singleServiceTime from '@xt/client/experimental/server-time'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ClickEvent } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class SectionItemSecond extends Mixins(MixinsHomeClick) {
  @Prop() config: {
    productId: number
    signUpStartTime: string
    signUpEndTime: string
    startTime: string
    endTime: string
    cover: string
    event?: ClickEvent
    bg: string
  }

  getIsClickDisable() {
    const { signUpStartTime } = this.config

    return singleServiceTime.serviceDate.isBefore(signUpStartTime)
  }

  get btnText() {
    const now = AjaxBasics.serviceDate.utcOffset(+8)

    const { signUpStartTime, signUpEndTime, startTime, endTime } = this.config

    if (now.isBefore(signUpStartTime)) {
      return '报名未开始'
    } else if (now.isAfter(signUpStartTime) && now.isBefore(signUpEndTime)) {
      return '正在报名'
    } else if (now.isAfter(signUpEndTime) && now.isBefore(startTime)) {
      return '报名已结束'
    } else if (now.isAfter(startTime) && now.isBefore(endTime)) {
      return '开课中'
    } else {
      return '已结课'
    }
  }

  handleOpen() {
    if (this.config.event) {
      this.onClickEvent(this.config.event)
      return
    }

    if (this.getIsClickDisable()) return

    window.open(`/commodity/${this.config.productId}`)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
